export function makeId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID(); // modern browsers
  }
  return `tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}